import { FlyoutContent } from "@amzn/stencil-react-components/flyout";
import { Col } from "@amzn/stencil-react-components/layout";
import React, { FC } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { MessagesView } from "./messages-view";
import { NoMessagesView } from "./no-messages-view";
import { OrderMessagesFlyoutProps } from "./order-messages-flyout.types";
import { useOrderMessages } from "@/hooks/use-order-messages";
import { usePostComment } from "@/hooks/use-post-comment";

export const OrderMessagesFlyout: FC<OrderMessagesFlyoutProps> = ({
  onClose,
  title,
  isSupportRequested,
  orderTaxId,
  orderReference,
}) => {
  const { data: messages, isLoading, isError } = useOrderMessages(orderTaxId);
  const postComment = usePostComment();
  const queryClient = useQueryClient();

  const submitComment = async (taxonomyId: string, comment: string): Promise<boolean> => {
    try {
      await postComment.mutateAsync({ taxonomyId, message: comment });
      await queryClient.invalidateQueries({ queryKey: ["order-messages", orderTaxId] });
      return true;
    } catch {
      return false;
    }
  };

  return (
    <FlyoutContent
      titleText="Order Messages"
      onCloseButtonClick={onClose}
      maxWidth="600px"
    >
      <Col>
        {isSupportRequested ? (
          <MessagesView
            title={title}
            messages={messages}
            order={orderTaxId}
            orderReference={orderReference}
            submitComment={submitComment}
            isLoading={isLoading}
            isSubmitting={postComment.isPending}
            hasError={isError}
          />
        ) : (
          <NoMessagesView />
        )}
      </Col>
    </FlyoutContent>
  );
};
